import React, { Component } from "react"
import PropTypes from "prop-types"
import { Box } from "rebass"
import { differenceWith, isEqual } from "lodash"
import Chips, { Chip } from "react-chips"
import { GET_LIST } from "admin-on-rest"
import { pink500, cyan500 } from "material-ui/styles/colors"
import { RestClient } from "../../restClient"

class SearchMarketerCampaignChip extends Component {
  constructor(props) {
    super(props)
    this.state = {
      chips: [],
      tempSuggestions: [],
      dataUsers: [],
      isLoadUsers: true,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data && nextProps.data.length > 0 && this.state.isLoadUsers) {
      this.setState({
        chips: nextProps.data,
        dataUsers: nextProps.data,
        isLoadUsers: false,
      })
    }
  }

  onChange = chips => {
    if (chips.length > this.state.chips.length) {
      //add
      const addItem = differenceWith(chips, this.state.chips, isEqual)
      if (addItem.length > 0) {
        if (this.props.singleInput) {
          if (this.state.chips.length < 1) {
            this.onAddItemUser(addItem, chips)
          }
        } else {
          this.onAddItemUser(addItem, chips)
        }
      }
    } else if (chips.length < this.state.chips.length) {
      this.props.onChangeUser(chips)
      this.setState({ chips })
    }
  }
  onAddItemUser = (addItem, chips) => {
    this.props.onChangeUser(chips)
    this.setState({ chips })
  }

  fetchSuggestions = value => {
    return new Promise((resolve, reject) => {
      // RestClient(GET_LIST, "marketers", {
      //   pagination: { page: 1, perPage: 100 },
      //   sort: { field: "first_name", order: "ASC" },
      //   filter: {},
      // })
      //   .then(items => {
      //     console.log(items)
      //     this.setState({ marketers: items.data })
      //   })
      //   .catch(e => {
      //     //console.error(e);
      //   })
      RestClient(GET_LIST, "marketers", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "first_name", order: "ASC" },
        filter: { search: value },
      })
        .then(items => {
          let content = []
          items.data.map((item, index) => {
            return content.push(`${item.first_name} ${item.last_name}`)
          })
          this.setState({
            tempSuggestions: items.data,
          })
          resolve(items.data)
        })
        .catch(e => {
          resolve([])
        })
      // if (value.length >= 3) {
      // } else {
      //   resolve([]);
      // }
    })
  }

  render() {
    return (
      <div>
        <BoxTitle pt={[1]}>Users</BoxTitle>
        <Box py={[1]}>
          <Chips
            theme={theme}
            renderChip={(item, index) => (
              <Chip theme={chipTheme} key={index}>
                {item.first_name} {item.last_name}
              </Chip>
            )}
            value={this.state.chips}
            onChange={this.onChange}
            placeholder="input User"
            shouldRenderSuggestions={value => value.trim().length > 0}
            fetchSuggestions={this.fetchSuggestions}
            fromSuggestionsOnly={true}
            renderSuggestion={(item, { query }) => (
              <div key={item.id}>
                {item.first_name} {item.last_name}
              </div>
            )}
            suggestionsFilter={(opt, val) =>
              opt.id.toLowerCase().indexOf(val.toLowerCase()) !== -1
            }
            getSuggestionValue={suggestion => suggestion.id}
          />
        </Box>
      </div>
    )
  }
}

const BoxTitle = Box.extend`
  font-family: Ubuntu, sans-serif;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.3);
`

const chipTheme = {
  chip: {
    border: "10px",
    boxSizing: "border-box",
    display: "flex",
    cursor: "pointer",
    textDecoration: "none",
    margin: "4px",
    color: "white",
    padding: "4px 8px 4px 8px",
    outline: "none",
    fontSize: "inherit",
    fontWeight: "inherit",
    position: "relative",
    backgroundColor: cyan500,
    borderRadius: "16px",
    whiteSpace: "nowrap",
    width: "fit-content",
    alignItems: "center",
    float: "left",
  },
  chipSelected: {
    background: "#888",
  },
  chipRemove: {
    color: "white",
    fill: "white",
    height: "24px",
    width: "24px",
    userSelect: "none",
    transition: "all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
    cursor: "pointer",
    margin: "0px -4px 0px 8px",
    fontSize: "2.2em",

    fontWeight: "bold",
    display: "flex",
    alignItems: "center",
    ":hover": {
      color: pink500,
    },
  },
}

const theme = {
  chipsContainer: {
    display: "flex",
    position: "relative",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    font: "13.33333px Ubuntu",
    minHeight: 24,
    alignItems: "center",
    flexWrap: "wrap",
    padding: "2.5px",
    borderRadius: 0,
    ":focus": {
      border: "1px solid #aaa",
    },
  },
  container: {
    flex: 1,
  },
  containerOpen: {},
  input: {
    border: "none",
    outline: "none",
    boxSizing: "border-box",
    width: "100%",
    padding: 5,
    margin: 2.5,
  },
  suggestionsContainer: {},
  suggestionsList: {
    position: "absolute",
    border: "1px solid #ccc",
    zIndex: 2100,
    left: 0,
    top: "100%",
    width: "100%",
    backgroundColor: "#fff",
    listStyle: "none",
    padding: 0,
    margin: 0,
  },
  suggestion: {
    padding: "5px 15px",
  },
  suggestionHighlighted: {
    background: "#ddd",
  },
  sectionContainer: {},
  sectionTitle: {},
}

SearchMarketerCampaignChip.propTypes = {
  data: PropTypes.array,
  nameUsers: PropTypes.array,
  onChangeUser: PropTypes.func,
  singleInput: PropTypes.bool,
}
SearchMarketerCampaignChip.defaultProps = {
  data: [],
  nameUsers: [],
  singleInput: false,
}
export default SearchMarketerCampaignChip



// WEBPACK FOOTER //
// ./src/components/searchchip/SearchMarketerCampaignChip.js